import Joi from 'joi';

// createLayout — generated by FormBuilder, hand-edit after.
export const createLayout = () => ({
    rk: { label: 'RK', control: 'text' },
    uid: { label: 'Uid', control: 'text' },
    tabId: { label: 'Tab Id', control: 'text' },
    component: { label: 'Component', control: 'text' },
    posX: { label: 'Pos X', control: 'text', layout: 'top' },
    posY: { label: 'Pos Y', control: 'text', layout: 'top' },
    height: { label: 'Height', control: 'text', layout: 'top' },
    width: { label: 'Width', control: 'text', layout: 'top' },
    ems: { label: 'Ems', control: 'text' },
});

// createSchema — .label() from createLayout() keeps Joi errors + UI labels in sync.
export const createSchema = () => {
    const layout = createLayout();
    return {
    rk: Joi.string().max(256).allow(null, '').label(layout.rk.label),
    uid: Joi.string().max(256).allow(null, '').label(layout.uid.label),
    tabId: Joi.string().max(256).allow(null, '').label(layout.tabId.label),
    component: Joi.string().max(256).allow(null, '').label(layout.component.label),
    posX: Joi.number().label(layout.posX.label),
    posY: Joi.number().label(layout.posY.label),
    height: Joi.number().label(layout.height.label),
    width: Joi.number().label(layout.width.label),
    ems: Joi.number().label(layout.ems.label),
    };
};

export const createEmpty = () => ({
    rk: '',
    uid: '',
    tabId: '',
    component: '',
    posX: 0,
    posY: 0,
    height: 0,
    width: 0,
    ems: 0,
});
